import type {DynamoEnvValueType} from './types';

export const dynamoTextualContentToListOfElements = (
  x: DynamoEnvValueType<string>
) => {
  if (x === null) {
    return [];
  }

  return x.tag === 'Some'
    ? [
        {
          text: true,
          type: null,
          id: 'temp',
          children: [],
          data: {value: x.val},
        },
      ]
    : [];
};

export const dynamoTextualContentToText = (x: DynamoEnvValueType<string>) => {
  if (x === null || x.tag === 'None') {
    return '';
  }

  return x.val;
};
